import ApiHttp from '../http';
import {Movie, Movies} from '../../model';
import FilmFestival from '../model/FilmVestival'

class FilmFestivalService {
	/**
     * Service for interacting with the film festivals api
     */
    constructor() {
        this.filmfestivals = undefined;
        this.filmFestival = undefined;
    }
	/**
     *
     * @returns {Promise.<FilmFestivals>|*}
     */
    getFilmFestivals() {
        return this.filmfestivals = this.filmfestivals || ApiHttp.get(`/film-festivals`)
                .then(
                    (response) => { return response.data },
                    (error) => {
                        this.filmfestivals = undefined;
                        return Promise.reject(error);
                    }
                )


    }

    getFilmFestivalById(id) {

    	return this.filmFestival = ApiHttp.get(`/film-festivals`)
                .then(
                    (response) => { 
                    	var FilmFestivals = response.data

                    	for(var i = 0; i < FilmFestivals.length; i++) {
				    		if(id == FilmFestivals[i].ID) {
				    			this.filmFestival = FilmFestivals[i]
				    		}
				    	}
				    	return new FilmFestival(this.filmFestival)
                    },
                    (error) => {
                        return Promise.reject(error);
                    }
                )    	
    }
}

export default new FilmFestivalService();


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/film-festival-service.js